// @flow
import {format, parseISO} from 'date-fns';
import type {TDateProps} from 'modules/common/types';

/**
 * Получение даты\времени в нужном формате
 * Пример как будет дата с бэка приходить в Гринвиче 2020-05-20T08:58:38+00:00
 *
 * Пример для formatType HH:mm:ss | dd/MM/yyyy | dd.MM.yyyy
 *
 * @param date дата в iso формате
 * @param formatType формат даты\времени
 * @returns {string} дата\время в нужном формате
 */
export const formatDate = ({date, formatType = 'dd/MM/yyyy'}: TDateProps = {}): string => {
    const dateISO = date && parseISO(date);
    const currentDate = dateISO ? new Date(dateISO) : new Date();

    return format(currentDate, formatType);
};

/**
 * Очищает маску из значений
 *
 * @param inputValue значение из инпута с маской через точки
 * @param rule какие символы вырезать
 * @returns {string} строка без маски
 */
export const getInputChars = (inputValue: string, rule: RegExp): string => inputValue.replace(rule, '');

/**
 * Проверка что значение не заполено в маске
 *
 * @param inputValue значение из инпута с маской
 * @param rule правило
 * @returns {boolean} Значение заполнено
 */
export const isFullDate = (inputValue: string, rule: RegExp): boolean => 8 === getInputChars(inputValue, rule).length;
